module.exports = __webpack_public_path__ + "static/media/background2.91f9f23f.jpg";